/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { FormHandles } from '@unform/core';

import Button from '../../../../../components/Button';
import Loading from '../../../../../components/Loading';

import Modal from '../../../../../components/Modal';

import { Container, Content, ActionSaveModal } from './styles';

interface ModalDTO {
  formRef: any | FormHandles;
  loadModalProp: boolean;
  closeModalFinishedProjectAndReleaseBilling: () => void;
}

const ModalConfirmationFinishedProjectAndReleaseBilling: React.FC<ModalDTO> = ({
  formRef,
  loadModalProp = false,
  closeModalFinishedProjectAndReleaseBilling,
}) => {
  return (
    <Modal visibleProp={loadModalProp}>
      <Container>
        <h1>
          Deseja marcar como projeto concluído e liberar para faturamento?
        </h1>
        <Content>
          <ActionSaveModal>
            <Button
              type="button"
              onClick={() => {
                formRef.current.setFieldValue(
                  'finishedProjectAndReleaseBilling',
                  true,
                );
                closeModalFinishedProjectAndReleaseBilling();
              }}
            >
              Sim
            </Button>
            <Button
              type="button"
              onClick={() => {
                formRef.current.setFieldValue(
                  'finishedProjectAndReleaseBilling',
                  false,
                );
                closeModalFinishedProjectAndReleaseBilling();
              }}
            >
              Não
            </Button>
          </ActionSaveModal>
        </Content>
      </Container>
    </Modal>
  );
};

export default ModalConfirmationFinishedProjectAndReleaseBilling;
